const svg = document.querySelector('[data-sj-frame-svg]');
const frameEl = document.querySelector('.sj-frame');
const scrollArea = document.querySelector('.sj-frame-scroll-area');
const root = document.documentElement;
let blinkEnabled = frameEl.classList.contains('sj-frame--blink');
let lockDraw = false;

const evenCount = (length, minPitch) => {
  const raw = Math.max(8, Math.round(length / minPitch));
  return raw % 2 === 0 ? raw : raw + 1;
};

const roundedRectPath = (x, y, w, h, r) => {
  const radius = Math.max(0, Math.min(r, w / 2, h / 2));
  return (
    'M' +
    (x + radius) +
    ',' +
    y +
    ' H' +
    (x + w - radius) +
    ' A' +
    radius +
    ',' +
    radius +
    ' 0 0 1 ' +
    (x + w) +
    ',' +
    (y + radius) +
    ' V' +
    (y + h - radius) +
    ' A' +
    radius +
    ',' +
    radius +
    ' 0 0 1 ' +
    (x + w - radius) +
    ',' +
    (y + h) +
    ' H' +
    (x + radius) +
    ' A' +
    radius +
    ',' +
    radius +
    ' 0 0 1 ' +
    x +
    ',' +
    (y + h - radius) +
    ' V' +
    (y + radius) +
    ' A' +
    radius +
    ',' +
    radius +
    ' 0 0 1 ' +
    (x + radius) +
    ',' +
    y +
    ' Z'
  );
};

/**
 * Sized to the scroll area's own rendered box, not the viewport — this frame is real page
 * content that runs the full height of the page (header through footer) and scrolls with
 * it, not a fixed HUD. A ResizeObserver on the scroll area redraws it whenever that height
 * changes (content load, breakpoint change, dynamic content), so no scroll listener is
 * needed at all.
 */
let drawnWidth = 0;
let drawnHeight = 0;

const pinScroll = (scrollX, scrollY) => {
  if (window.scrollX !== scrollX || window.scrollY !== scrollY) {
    window.scrollTo(scrollX, scrollY);
  }
};

const draw = () => {
  if (!svg || !scrollArea || lockDraw) return;

  const width = scrollArea.clientWidth;
  const height = Math.max(scrollArea.scrollHeight, scrollArea.clientHeight);
  if (!width || !height) return;

  // Pin the frame to the content box. After the blink, WebKit was shrink-wrapping
  // it around a short viewBox and the lights collapsed into the product photo.
  frameEl.style.height = height + 'px';

  // Same box as last time: dropping the glow bulbs is enough. Rebuilding the
  // SVG makes WebKit throw the page back to the top.
  if (width === drawnWidth && height === drawnHeight) {
    if (!blinkEnabled) {
      svg.querySelectorAll('.sj-frame__lit').forEach(function (node) {
        node.remove();
      });
    }
    return;
  }

  const wide = window.matchMedia('(min-width: 750px)').matches;
  const pad = 1;
  const innerStroke = wide ? 1 : 0.85;
  const bulbR = wide ? 7.2 : 4.6;
  const gap = wide ? 5 : 3.5;
  const rxOuter = wide ? 20 : 12;
  const pitch = wide ? 30 : 20;
  const innerInset = gap * 2 + bulbR * 2 + innerStroke / 2;
  const midInset = gap + bulbR;

  const frameSize = pad + innerInset + innerStroke / 2;
  root.style.setProperty('--sj-frame-size', frameSize + 'px');

  const scrollX = window.scrollX;
  const scrollY = window.scrollY;

  // Stretch the drawing to the frame box. The default "meet" fit letterboxes a
  // mismatched viewBox into a short band through the middle of the page.
  svg.setAttribute('preserveAspectRatio', 'none');
  svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
  svg.setAttribute('width', '100%');
  svg.setAttribute('height', '100%');

  const outerX = pad;
  const outerY = pad;
  const outerW = width - pad * 2;
  const outerH = height - pad * 2;
  const innerX = outerX + innerInset;
  const innerY = outerY + innerInset;
  const innerW = outerW - innerInset * 2;
  const innerH = outerH - innerInset * 2;
  const rxInner = Math.max(4, rxOuter - innerInset);

  const midX = outerX + midInset;
  const midY = outerY + midInset;
  const midW = outerW - midInset * 2;
  const midH = outerH - midInset * 2;
  const rxMid = Math.max(6, rxOuter - midInset);

  const outerD = roundedRectPath(outerX, outerY, outerW, outerH, rxOuter);
  const innerD = roundedRectPath(innerX, innerY, innerW, innerH, rxInner);
  const midD = roundedRectPath(midX, midY, midW, midH, rxMid);

  const measure = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  measure.setAttribute('d', midD);
  svg.appendChild(measure);
  const length = measure.getTotalLength();
  const count = evenCount(length, pitch);
  const step = length / count;
  const bulbs = [];
  for (let i = 0; i < count; i++) {
    const point = measure.getPointAtLength(i * step);
    bulbs.push({ x: point.x, y: point.y, odd: i % 2 === 0 });
  }
  measure.remove();

  const bulbCircles = bulbs
    .map(function (bulb) {
      return (
        '<circle class="sj-frame__bulb" cx="' +
        bulb.x.toFixed(2) +
        '" cy="' +
        bulb.y.toFixed(2) +
        '" r="' +
        bulbR +
        '"/>'
      );
    })
    .join('');

  const litCircles = blinkEnabled
    ? bulbs
        .map(function (bulb) {
          return (
            '<circle class="sj-frame__lit ' +
            (bulb.odd ? 'sj-frame__lit--odd' : 'sj-frame__lit--even') +
            '" cx="' +
            bulb.x.toFixed(2) +
            '" cy="' +
            bulb.y.toFixed(2) +
            '" r="' +
            (bulbR * 1.35).toFixed(2) +
            '"/>'
          );
        })
        .join('')
    : '';

  svg.innerHTML =
    '<defs>' +
    '<radialGradient id="sj-bulb-fill" cx="35%" cy="32%" r="70%">' +
    '<stop offset="0%" stop-color="#ffffff"/>' +
    '<stop offset="38%" stop-color="#fff4a3"/>' +
    '<stop offset="100%" stop-color="#fce914"/>' +
    '</radialGradient>' +
    '<radialGradient id="sj-bulb-lit" cx="40%" cy="35%" r="70%">' +
    '<stop offset="0%" stop-color="#ffffff"/>' +
    '<stop offset="55%" stop-color="#ffffff" stop-opacity="0.85"/>' +
    '<stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>' +
    '</radialGradient>' +
    '</defs>' +
    '<path fill="#00a853" fill-rule="evenodd" d="' +
    outerD +
    ' ' +
    innerD +
    '"/>' +
    '<path fill="none" stroke="#111111" stroke-linejoin="round" stroke-width="' +
    innerStroke +
    '" d="' +
    innerD +
    '"/>' +
    bulbCircles +
    litCircles;

  drawnWidth = width;
  drawnHeight = height;
  pinScroll(scrollX, scrollY);
  window.requestAnimationFrame(function () {
    pinScroll(scrollX, scrollY);
  });
};

draw();

if (blinkEnabled) {
  const blinkMs = Number(frameEl.dataset.sjFrameBlinkMs) || 3000;
  lockDraw = true;
  window.setTimeout(function () {
    blinkEnabled = false;
    frameEl.classList.remove('sj-frame--blink');
    lockDraw = false;
    draw();
  }, blinkMs);
}

if (scrollArea) {
  const resizeObserver = new ResizeObserver(function () {
    draw();
  });
  resizeObserver.observe(scrollArea);
}
